import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { loadingAnimation } from "../../animations/animations";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  root: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  loader: {
    minWidth: 0,
    width: "45px",
    height: "45px",
    padding: "0",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "100%",
    transition: "all 0.4s 0.2s cubic-bezier(.9,.1,.1,.9)",
    color: "primary.main",

    animation: `${loadingAnimation("#5C61FF")} 2s  infinite`,
    ":before": {
      display: "none",
    },
  },
};
